<template>
  <div>
    <template v-if="isNew">
      <v-form
          ref="form"
          v-model="valid"
          lazy-validation
          @submit.prevent="buscar()"
      >
        <v-row class="text-center">
          <v-col cols="12" md="6" offset-md="3" class="text-center">
            <v-text-field
                v-model="cuenta"
                label="Número de cuenta *"
                v-mask="'#######'"
                outlined
                autofocus
                clearable
                class="centered-input"
                :rules="[v => !!v || 'Cuenta es requerida',
                   v => v?.toString().length >= 7 || 'Cuenta debe tener exactamente 7 dígitos']"
                ref="txtCuenta"
                :loading="loading"
                :disabled="loading"
            />
          </v-col>
        </v-row>
      </v-form>
    </template>

    <template v-else>
      <v-card-text>
        <table style="width: 100%; font-size: 1.15em">
          <tr>
            <td>Nombre: <strong>{{ cuenta }}</strong> | {{ cliente.nombre }}</td>
            <td>
              <div v-if="cliente.rucnit">CI/NIT {{ cliente.rucnit }}</div>
              <div v-else class="animate">CI/NIT no registrado</div>
            </td>
            <td class="text-right">Categoría: {{ cliente.categoria }}</td>
          </tr>
          <tr>
            <td>Dirección: {{ cliente.direccion }}</td>
            <td>
              <div v-if="cliente.email">Email: {{ cliente.email }}</div>
              <div v-else class="animate">Email no registrado</div>
            </td>
            <td class="text-right font-weight-bold info--text">Meses deuda: {{ consumos.length }}</td>
          </tr>
        </table>
      </v-card-text>

      <div>
        <v-data-table
            :headers="headers"
            :items="consumos"
            fixed-header
            hide-default-footer
            disable-pagination
            height="30vh"
            dense
        >
          <template v-slot:item.pla_nmes="props">

            <v-chip
                v-if="props.item.pla_codi === '9'"
                color="green"
                small
                text-color="white"
                style="margin-left: -10px"
                dark
            >
              <v-avatar
                  left
                  class="green darken-4"
              >
                {{ props.index+1 }}
              </v-avatar>
              Conciliación
            </v-chip>
            <span v-else>{{ props.index +1 }}</span>
          </template>
          <template v-slot:item.formulario="props">
            <span v-if="props.item.pla_codi === '9'">{{ props.item.formulario | round }}</span>
            <span v-else>{{ props.item.formulario | round }}</span>
          </template>
          <template v-slot:item.costoagua="props">
            <span v-if="props.item.pla_codi === '9'">{{ props.item.costoagua | round }}</span>
            <span v-else>{{ props.item.costoagua | round }}</span>
          </template>
          <template v-slot:item.monto="props">
            <strong v-if="props.item.pla_codi === '9'">{{ props.item.monto | round }}</strong>
            <strong v-else>{{ props.item.monto | round }}</strong>
          </template>
          <template v-slot:item.seleccion="props">
            <td @click="seleccionarFacturas(props.item)" class="text-right" style="cursor: pointer; width: 50px">
              <v-icon v-if="props.item.selected" color="primary">mdi-checkbox-marked</v-icon>
              <v-icon v-else color="primary">mdi-checkbox-blank-outline</v-icon>
            </td>
          </template>
          <template v-slot:body.append>
            <tr>
              <td colspan="2" class="text-right font-weight-light">DEUDA CONSUMO AGUA</td>
              <td class="text-right font-weight-light">{{ sumFormulario() | round }}</td>
              <td class="text-right font-weight-light">{{ sumCostoAgua() | round }}</td>
              <td class="text-right font-weight-light">{{ totalConsumoAgua | round }}</td>
              <td style=" width: 50px"></td>
            </tr>
          </template>
        </v-data-table>
      </div>
<!--      <pre>{{cuotas}}</pre>-->
      <v-alert
          v-if="cuotas"
          outlined
          color="blue"
      >
        <div>
          <v-row>
            <v-col cols="6">CUOTAS DE CREDITOS:</v-col>
            <v-col cols="6" class="text-right">
              <v-btn
                  color="red"
                  outlined
                  x-small
                  v-if="interesCero"
                  class="text-none"
                  @click="desmarcarCuotas"
              >
                <v-icon left>mdi-trash-can-outline</v-icon>
                Desmarcar
              </v-btn>
<!--              <pre>{{interesCero}}</pre>-->
            </v-col>
          </v-row>
        </div>
        <v-simple-table dense>
          <template v-slot:default>
            <thead>
            <tr>
              <th>#</th>
              <th>Amortizacion</th>
              <th>Interes</th>
              <th class="text-right">Monto (Bs)</th>
              <th class="text-right"></th>
            </tr>
            </thead>
            <tbody>
            <tr v-for="(item, index) in cuotas" :key="index">
              <td>{{ item.numero_cuota }}</td>
              <td>{{ item.amortizacion }}</td>
              <td>{{ item.interes_pagado | round }}</td>
              <td class="text-right font-weight-bold">{{ parseFloat(item.amortizacion) + parseFloat(item.interes_pagado) | round }}</td>
              <td @click="seleccionarCuota(item)" class="text-right" style="cursor: pointer; width: 50px">
                <v-icon v-if="item.selected" color="primary">mdi-checkbox-marked</v-icon>
                <v-icon v-else color="primary">mdi-checkbox-blank-outline</v-icon>
              </td>
            </tr>
            <tr>
              <td colspan="3" class="text-right font-weight-light">
                TOTAL CUOTAS
              </td>
              <td class="text-right font-weight-light">{{
                  totalCuotas | round2
                }}
              </td>
              <td style="width: 65px"></td>
            </tr>
            </tbody>
          </template>
        </v-simple-table>
      </v-alert>
      <v-alert
          v-if="(parseFloat(totalOtrosIngresos) !== (parseFloat( montoFormulario)+parseFloat(montoInteres)) ) && totalOtrosIngresos>0"
          outlined
          color="warning"
      >
        <div>
          DETALLE OTROS INGRESOS:
        </div>
        <v-simple-table dense>
          <template v-slot:default>
            <thead>
            <tr>
              <th>#</th>
              <th>Descripción</th>
              <th class="text-right">Monto (Bs)</th>
            </tr>
            </thead>
            <tbody>
            <template v-for="(item, index) in otrosIngresos">
              <tr v-if="item.cuenta==2218 && !valorCreditoCero" :key="index">
                <td>{{ index + 1 }}</td>
                <td>{{ item.concepto }}</td>
                <td class="text-right font-weight-bold">{{ item.valor | round }}</td>
              </tr>
              <tr :key="index" v-else-if="item.valor>0 && item.cuenta !==2218">
                <td>{{ index + 1 }}</td>
                <td>{{ item.concepto }}</td>
                <td class="text-right font-weight-bold">{{ item.valor | round }}</td>
              </tr>
            </template>
            <tr>
              <td colspan="2" class="text-right font-weight-light">DEUDA OTROS INGRESOS
              </td>
              <td class="text-right font-weight-light">
<!--                {{(totalOtrosIngresos - restarUnFormulario) | round2 }}-->
                {{(totalOtrosIngresos) | round2 }}
              </td>
<!--              <td style="width: 65px"></td>-->
            </tr>
            </tbody>
          </template>
        </v-simple-table>
      </v-alert>
<!--      <pre>{{otrosIngresos}}</pre>-->
<!--      <pre>{{cuotas}}</pre>-->
<!--      <pre>{{selectedCoutas}}</pre>-->

      <v-row style="margin-top: -20px">
        <v-col cols="12" md="3">
          <v-text-field
              v-model="montoRecibido"
              label="Monto recibido (Bs)"
              outlined
              dense
              autofocus
              class="mt-2"
              ref="montoRec"
              @keypress="patterns.onlyDecimal($event)"
              @keyup.enter="guardar()"
          />
        </v-col>
        <v-col cols="12" md="3">
          <div class="mt-4">
            Cambio (Bs):
            <span v-if="cambio >= 0">{{ cambio | round }}</span>
          </div>
        </v-col>
        <v-col cols="12" md="6">
          <v-alert
              dense
              outlined
              text
              color="info"
              class="text-right font-weight-bold text-sm-h6"
          >
            TOTAL A PAGAR (Bs): <strong>{{ total | round }}</strong>
          </v-alert>
        </v-col>
      </v-row>
    </template>

    <v-footer v-if="!isNew" class="mb-3">
        <span class="font-weight-bold">
          ( {{ totalSeleccionados + (otrosIngresos.length > 0 ? 1 : 0) }} ) Facturas para imprimir
        </span>

      <v-spacer/>
      <v-btn
          color="primary"
          :disabled="isNew && totalSeleccionados <= 0"
          @click="guardar()"
          :loading="loading"
      >
        Guardar pago
      </v-btn>
      <v-btn
          class="ml-2"
          outlined
          color="secundary"
          @click="cancelar()"
      >
        Nuevo
      </v-btn>
    </v-footer>

    <div id="myElement">
    </div>
  </div>
</template>

<script lang="ts">
import {Component, Vue} from "vue-property-decorator";
import {Alert} from "@/addons/Alert";
import {RecaudacionService} from "@/services/RecaudacionService";
import {recaudacionStore} from "@/store/recaudacionStore";
import {FacturaConsumoAgua} from "@/models/FacturaConsumoAgua";
import {Pattern} from "@/addons/Pattern";
import {globalStore} from "@/store/globalStore";
import {PrintConsumo} from "@/addons/PrintConsumo";
import moment from "moment";
@Component({
  name: "RecaudacionConsumoAgua",
})
export default class RecaudacionConsumoAgua extends Vue {
  private patterns = Pattern;
  private recaudacionService = RecaudacionService.getInstance();
  private recaudacionStore = recaudacionStore();
  private globalStore = globalStore();

  private cuenta = null;
  private montoRecibido = null;
  valid = true;
  $refs!: {
    form: HTMLFormElement,
    txtCuenta: HTMLInputElement,
    montoRec: HTMLInputElement,
  };

  private headers = [
    {text: "Mes. Deuda.", value: "pla_nmes", sortable: false},
    {text: "Periodo", value: "periodo", sortable: false},
    {text: "Formularo (Bs)", value: "formulario", align: 'end', sortable: false},
    {text: "Agua (Bs)", value: "costoagua", align: 'end', sortable: false},
    {text: "Monto (Bs)", value: "monto", align: 'end', sortable: false},
    {text: "", value: "seleccion", sortable: false},
  ];
  desmarcarCuotas(){
    this.cuotas.forEach((item) => {
      item.selected = false;
    });
    this.otrosIngresos.forEach((item) => {
      if (item.es_credito) {
        item.valor = this.totalCuotas;
      }
    })
  }

  get cliente() {
    return this.recaudacionStore.facturaConsumoAgua.cliente;
  }
  get cuotas() {
    return this.recaudacionStore.facturaConsumoAgua.cuotas;
  }
  get interesCero() {
    let otrosIngresos = this.recaudacionStore.facturaConsumoAgua.otrosIngresos;
    if (otrosIngresos){
      let find = otrosIngresos.find((item) => {
        return item.cuenta == "2218";
      });
      if (find){
        const hoy = moment().format('YYYY-MM-DD');
        const cuotas = this.cuotas;
        const cuotaFirst = cuotas[0];
        if (cuotaFirst.fecha_programacion > hoy){
          return true;
        }
        return find.valor==0;
      }else{
        return true;
      }
    }
    return true;
  }

  get montoFormulario(){
    let otrosIngresos = this.recaudacionStore.facturaConsumoAgua.otrosIngresos;
    if (otrosIngresos){
      let find = otrosIngresos.find((item) => {
        return item.cuenta == "2216";
      });
      if (find){
        return find.valor;
      }else{
        return 0;
      }
    }
    return 0;
  }
  get montoInteres(){
    let otrosIngresos = this.recaudacionStore.facturaConsumoAgua.otrosIngresos;
    if (otrosIngresos){
      let find = otrosIngresos.find((item) => {
        return item.cuenta == "2218";
      });
      if (find){
        return find.valor;
      }else{
        return 0;
      }
    }
    return 0;
  }
  get valorCreditoCero(){
    let otrosIngresos = this.recaudacionStore.facturaConsumoAgua.otrosIngresos;
    if (otrosIngresos){
      let find = otrosIngresos.find((item) => {
        return item.es_credito;
      });
      if (find){
        return find.valor==0;
      }else{
        return false;
      }
    }
    return false;
  }

  get consumos(): any[] {
    return this.recaudacionStore.facturaConsumoAgua.facturas;
  }

  get otrosIngresos(): any[] {
    return this.recaudacionStore.facturaConsumoAgua.otrosIngresos;
  }

  get isNew(): boolean {
    return this.recaudacionStore.isNewConsumoAgua;
  }

  get loading(): boolean {
    return this.recaudacionStore.loading;
  }

  get totalSeleccionados(): number {
    return this.consumos.reduce((acc, item) => {
      if (item.selected)
        return acc + 1;
      else
        return acc;
    }, 0)
  }

  get totalConsumoAgua(): number {
    return this.consumos.reduce((acc, item) => {
      if (item.selected) {
        if (item.pla_codi === '9')
          return parseFloat(acc) + parseFloat(item.monto);
        else
          return parseFloat(acc) + parseFloat(item.monto);

      } else {
        return acc;
      }
    }, 0.0)
  }

  sumCostoAgua() {
    return this.consumos.reduce((a: number, item: any) => {
      if (item.pla_codi === '9')
        return a + parseFloat(item.costoagua);
      else
        return a + parseFloat(item.costoagua);
    }, 0.0)
  }

  sumFormulario() {
    return this.consumos.reduce((a: number, item: any) => {
      if (item.pla_codi === '9')
        return a;
      else
        return a + parseFloat(item.formulario);
    }, 0.0)
  }
  // const seMarcocoutas coimputed
  get selectedCoutas() {
    let select = false;
    if (this.cuotas) {
      this.cuotas.forEach((item) => {
        if (item.selected) {
          select = true;
        }
      });
    }
    return select;
  }

  get totalOtrosIngresos() {
    // return this.otrosIngresos.reduce((acc, item) => {
    //   return parseFloat(acc) + parseFloat(item.valor);
    // }, 0.0)

    let sum = 0;
    this.otrosIngresos.forEach((item) => {
      // console.log(item)
      // console.log('selectedCoutas', this.selectedCoutas)
      if (this.selectedCoutas == false){
        const cuentasNoaceptadas = [2218, 2123, 2127, 2124];
        if (!cuentasNoaceptadas.includes( parseInt(item.cuenta))){
          sum += parseFloat(item.valor);
        }
      }else{
        sum += parseFloat(item.valor);
      }
    })
    if (sum == this.montoFormulario) {
      sum = 0;
    }
    return sum;
  }
  get restarUnFormulario(){
    if (this.valorCreditoCero){
      return parseFloat(this.montoFormulario);
    }else{
      return 0;
    }
  }
  get totalCuotas(): number {
    let sum = 0;
    this.cuotas.forEach((item) => {
      if (item.selected){
        sum += parseFloat(item.amortizacion) + parseFloat(item.interes_pagado);
      }
    })
    return sum;
  }

  get total(): number {
    return this.totalConsumoAgua + this.totalOtrosIngresos;
  }
  get totalOtrosIngresosConCredito(): number {
    if (this.totalOtrosIngresos  === (parseFloat(this.montoFormulario)+parseFloat(this.montoInteres))) {
      return 0;
    }
    return this.otrosIngresos.reduce((acc, item) => {
      return parseFloat(acc) + parseFloat(item.valor);
    }, 0.0)
  }

  get cambio(): number {
    return (this.montoRecibido ?? 0) - this.total;
  }

  mounted() {
    this.cancelar();
  }

  round(value: number) {
    return Math.round(value * 100) / 100;
  }

  seleccionarFacturas(factura: any) {
    this.consumos.reduce((acc, item) => {
      if (parseInt(item.nrofactura) <= parseInt(factura.nrofactura)) {
        item.selected = true;
        return acc + 1;
      } else {
        item.selected = false;
        return acc + 1;
      }
    }, 0);

    //completar selecciones segun el minimo de factuas que puede cobrar
    this.completarSeleccionesPermitidad();

  }
  seleccionarCuota(cuota: any) {
    this.cuotas.reduce((acc, item) => {
      if (parseInt(item.numero_cuota) <= parseInt(cuota.numero_cuota)) {
        item.selected = true;
        return acc + 1;
      } else {
        item.selected = false;
        return acc + 1;
      }
    }, 0);
    this.otrosIngresos.forEach((item) => {
      if (item.es_credito) {
        item.valor = this.totalCuotas;
      }
    })
  }

  private completarSeleccionesPermitidad() {
    const porcentajeAsignado = this.globalStore.user.cajero?.cantidad_factura / 100;
    let cantidadPermitida = Math.ceil(this.consumos.length * porcentajeAsignado);
    cantidadPermitida = parseInt(cantidadPermitida.toString());

    if (this.totalSeleccionados < cantidadPermitida) {
      Alert.errorTop(`Debes seleccionar por lo menos <strong>${cantidadPermitida}</strong> facturas para cobrar`);

      this.consumos.reduce((acc, item) => {
        if (acc <= (cantidadPermitida - 1)) {
          item.selected = true;
          return acc + 1;
        } else {
          item.selected = false;
          return acc;
        }
      }, 0);
    }

    // if (this.totalSeleccionados > 10 ){
    //   Alert.errorTop(`No puedes seleccionar mas de 10 facturas para cobrar`);
    //   this.consumos.reduce((acc, item) => {
    //     if (acc <= 9) {
    //       item.selected = true;
    //       return acc + 1;
    //     } else {
    //       item.selected = false;
    //       return acc;
    //     }
    //   }, 0);
    // }
  }

  buscar() {
    if (!this.$refs.form.validate()) {
      return;
    }

    const data = {
      cuenta: this.cuenta
    }

    this.recaudacionService.getConsumoAgua(data);

    if (!this.isNew)
      this.$refs.montoRec?.focus();
  }

  cancelar() {
    this.recaudacionStore.isNewConsumoAgua = true;
    this.recaudacionStore.facturaConsumoAgua = new FacturaConsumoAgua();

    this.cuenta = null;
    this.montoRecibido = null;
    this.$refs.txtCuenta?.focus();
  }

  guardar() {
    const cantidadOtrosIngresos = this.otrosIngresos.length > 0 ? 1 : 0;
    Alert.confirm(`Resumen: <br>
                    Cliente: ${this.cuenta} <br>
                    Facturas para cobrar: ${this.totalSeleccionados + cantidadOtrosIngresos}<br/>
                    Total (Bs): ${this.round(this.total)}`
    ).then(res => {
      const data = this.recaudacionStore.facturaConsumoAgua;
      if (res.isConfirmed) {
        this.cancelar();
        this.recaudacionService.pagarConsumo(data).then((res) => {
          if (res) {
            this.imprimir(res);
          }
        });
      }
    })
  }

  private async imprimir(res: any) {
    const printConsumo = new PrintConsumo();

    for (const factura of res.facturas) {
      await printConsumo.imprimir(factura, res.cliente);
    }
  }
}
</script>

<style>
tbody tr:nth-of-type(even) {
  background-color: rgba(245, 245, 245);
}

tbody tr:nth-of-type(odd) {
  background-color: rgb(255, 255, 255);
}

.theme--light.v-data-table thead tr th {
  color: white;
}

.centered-input input {
  text-align: center;
  font-size: x-large;
}

.animate {
  text-align: center;
  animation-name: example;
  animation-duration: 2s;
  animation-iteration-count: 2;
  transition-delay: inherit;
  border-radius: 5px;
  background-color: red;
  color: white;
}

@keyframes example {
  from {
    font-weight: bold;
    background-color: red;
    color: white;
  }
  to {
    font-weight: normal;
    background-color: white;
    color: black;
  }
}

.flex-table > div {
  width: 100%;
}

@media screen {
  #myElement {
    display: none;
  }
}
</style>
